import { useColumnOrderPreference, useUserPreferences } from '../../user-preferences/hooks';
import type { UseColumnOrderPreferenceReturn } from '../../user-preferences/hooks';
import { CUSTOMERS_TABLE_COLUMN_ORDER_KEY } from '../types/customer.types';

// ─── Constants ────────────────────────────────────────────────────────────────

const PREFERENCE_KEYS = [CUSTOMERS_TABLE_COLUMN_ORDER_KEY];

// ─── Types ────────────────────────────────────────────────────────────────────

export type UseCustomersColumnOrderReturn = UseColumnOrderPreferenceReturn;

// ─── Hook ─────────────────────────────────────────────────────────────────────

/** Loads and persists the customers table's column-order preference. */
export function useCustomersColumnOrder(): UseCustomersColumnOrderReturn {
  const { data: preferences } = useUserPreferences({ keys: PREFERENCE_KEYS });

  return useColumnOrderPreference({ key: CUSTOMERS_TABLE_COLUMN_ORDER_KEY, preferences });
}
